<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.createScholarship)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-70">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5>{{translate(locale.scholarshipInformation)}}</h5>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">{{translate(locale.required)}}</span>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<form-input v-model="scholarship.name" :label="locale.scholarshipName"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="scholarship.scholarship_type_id" :list="scholarship_type_list" :label="locale.scholarshipType"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="scholarship.location_country_id" :list="location_country_list" :label="locale.scholarshipLocation"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="scholarship.scholarship_degree_id" :list="scholarship_degree_list" :label="locale.scholarshipDegree"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-datetime v-model="scholarship.deadline_date" :label="locale.scholarshipDeadline" />
								</div>
							
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<Editor style="height: 500px;width: 100%;border-radius: 5px;"
										v-model="scholarship.content"
										api-key="ldywwz30g9zhdo7kgwt8jjimrbc7ypqozvkd0ur7vs8eg7uk"
										:init="editorConfig"/>
								</div>
								
							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-30">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5>{{translate(locale.scholarshipAttachment)}}</h5>
									<input type="file" ref="attachment" accept="" @change="handleAttachmentFile($event)" style="display: none"/>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="attachment in scholarship.attachment">
									<div  class="attachment-preview">
										<div style="width: 100%">
											<a :href="config.cdn + 'attachments/' + attachment.file_hash" target="_blank">{{attachment.name}}</a>
										</div>
										<i style="color: #f44336 !important; text-align: center; cursor: pointer;" class="material-icons" @click="remove(attachment.file_hash)">delete</i>
										
									</div>
								</div>

								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-if="scholarship.attachment.length < 10">
									<div  class="attachment-upload" style="cursor:pointer" @click="$refs.attachment.click()">
										<loading v-if="attachment_uploading"/>
										<div v-else style="display: flex; justify-content: center; justify-items: center;">
											<i style="color: #999; text-align: center;" class="material-icons">attachment</i>
											<span style="color: #999; text-align: center;margin-left: 5px">{{translate(locale.upload)}}</span>
										</div>
									</div>
								</div>
							</div>	
						</div>
						<div class="md-layout-item md-size-100 text-right">
							<span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary" @click="createScholarship()">{{translate(locale.createScholarship)}}</md-button>
						</div>
					</div>
					
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>
	import Editor from '@tinymce/tinymce-vue';
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime, Editor },
		created() {
			this.getSettings();
		},

		data() {
			return {
				loaded: false,
				uploading: false,
				attachment_uploading: false,
				scholarship: {
					name: "",
					content: "",
					location_country_id: "",
					scholarship_type_id: "",
					scholarship_degree_id: "",
					deadline_date: "",
					deadline_timestamp: "",
					attachment: [],
					status: ""
				},
				location_country_list: [],
				scholarship_degree_list: [],
				scholarship_type_list: [],
				editorConfig: {
					height: 500,
					menubar: false,
					plugins: 'lists link image table code help wordcount',
					toolbar: 'undo redo | fontfamily fontsize | formatselect bold italic forecolor backcolor | image table | lineheight alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat| link code | help',
					font_family_formats: 'Arial=arial,helvetica,sans-serif; Courier New=courier new,courier,monospace; Moul=Moul; Siemreap=Siemreap; Hanuman=Hanuman;',
					automatic_uploads: true,
					images_upload_handler: this.handleEditorFile,
				},
				errors: []
			}
		},
		watch: {
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/profile/setting/scholarship").then(data => {

					this.location_country_list = this.config.clearList(data.body.data.country, this.$store.state.l.lang);
					this.scholarship_type_list = this.config.clearList(data.body.data.scholarship_type, this.$store.state.l.lang);
					this.scholarship_degree_list = this.config.clearList(data.body.data.scholarship_degree, this.$store.state.l.lang);
					this.loaded = true;
				})
			},
			createScholarship(draft = false) {

				if(draft) this.scholarship.status = 2;
				else this.scholarship.status = 1;

				this.scholarship.deadline_timestamp = (new Date(this.scholarship.deadline_date)).getTime();

				if(!this.checkValidation()) {
					this.$notification.notify({message: "Please fill in all required information.||សូមបំពេញព័ត៌មានឱ្យបានគ្រប់គ្រាន់។", icon: 'error', type: 'danger'});
					return;
				}

				this.$http.post(this.config.api + "/profile/scholarship/post", {
					scholarship: this.scholarship
				}).then(res => {
					if(res.body.status == 'success') {
						this.$notification.notify({
							message: "You have created your request for quotation/bidding successfully.",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/scholarship");
					}
				})
			},

			handleEditorFile(blobInfo, success, failure) {

				const formData = new FormData();
				formData.append('file', blobInfo.blob(), blobInfo.filename());

				this.$http.post(this.config.api + "/profile/upload/image_content", formData).then(res => {
					if (res.body.status == 'success') {
						success(this.config.cdn + res.body.data.image_hash);
					} else {
						failure("Error uploading image.");
					}
				})
			},
			handleAttachmentFile(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.attachment.files[0]);
				this.attachment_uploading = true;
				this.$http.post(this.config.api + "/profile/upload/attachment", formData).then(res => {
					this.attachment_uploading = false;
					if (res.body.status == 'success') {
						this.scholarship.attachment.push(res.body.data);
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if(String(this.scholarship.name).length < 3) this.errors.push("Title is empty.");
				if(String(this.scholarship.content).length < 3) this.errors.push("Content is empty.");
				if(String(this.scholarship.scholarship_type_id).length <= 0) this.errors.push("Scholarship Type is empty.");
				if(String(this.scholarship.location_country_id).length <= 0) this.errors.push("Scholarship Location is empty.");
				if(String(this.scholarship.scholarship_degree_id).length <= 0) this.errors.push("Scholarship Degree is empty.");
				if(String(this.scholarship.deadline_date).length <= 0 || parseInt(this.scholarship.deadline_timestamp) == NaN) this.errors.push("Scholarship Deadline is invalid.");

				if(this.errors.length == 0) return true;
				else return false;
			},
			remove(hash){
				const index = this.scholarship.attachment.findIndex((obj) => obj.file_hash == hash);
				if (index > -1) this.scholarship.attachment.splice(index, 1);
			},
		}
	}
</script>
<style scoped>
	.cover-image {
		border: 1px dashed #ccc; 
		min-height: 120px;
		/* margin-bottom: 8px;  */
		padding: 20px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: center; 
		align-items: center; 
		cursor:pointer
	}
	.gallery-image {
		border: 1px dashed #ccc; 
		min-height: 120px; 
		margin-bottom: 8px;
		padding: 20px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: center; 
		align-items: center
	}
	.attachment-preview {
		border: 1px dashed #ccc; 
		margin-bottom: 8px; 
		padding: 10px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: left; 
		align-items: center
	}
	.attachment-upload {
		border: 1px dashed #ccc; 
		margin-bottom: 8px; 
		padding: 8px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: center; 
		align-items: center
	}
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Scholarship/New.vue